import axios from 'axios'

const API_BASE = 'api/v1/claim'

export default {
  async getMessages(claimId) {
    try {
      const response = await axios.get(`${API_BASE}/${claimId}/messages`)
      return response.data
    }
    catch (error) {
      throw new Error(`Failed to fetch messages: ${error.message}`)
    }
  },

  async sendMessage(claimId, messageText, files = []) {
    try {
      const formData = new FormData();
      formData.append('messageText', messageText);

      if (files && files.length > 0) {
          for (let i = 0; i < files.length; i++) {
              formData.append('files', files[i]);
          }
      }

      const response = await axios.post(`${API_BASE}/${claimId}/messages`, formData, {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
      })
      return response.data
    }
    catch (error) {
      throw new Error(`Failed to send message: ${error.message}`)
    }
  },

  async getUnreadCount(claimId) {
    try {
      const response = await axios.get(`${API_BASE}/${claimId}/messages/unread-count`)
      return response.data.count
    }
    catch (error) {
      throw new Error(`Failed to fetch unread count: ${error.message}`)
    }
  },

  async markAsRead(claimId) {
    try {
      await axios.post(`${API_BASE}/${claimId}/messages/mark-as-read`)
    }
    catch (error) {
      throw new Error(`Failed to mark messages as read: ${error.message}`)
    }
  }
}
